export default __webpack_public_path__ + "static/Kenya-Group-donation-41afa312fc071c02a83c3abb4b48a586.png";